module.exports = __webpack_public_path__ + "media/images/layout/member_icon-d3b3198e92cae3efed51daae14ae5769.svg";